import { InjectionToken } from '@angular/core';

import { AppSettings } from '../../models';

export interface ConfigProvider {
  readonly loadOrder: number;
  getAppSettings(currentAppSettings: AppSettings): Promise<AppSettings>;
}

/**
 * Multi-provider token collecting every {@link ConfigProvider} that contributes
 * to the application configuration. {@link ConfigSettingsService} merges the
 * registered providers and applies them in ascending `loadOrder`.
 */
export const APP_CONFIG_PROVIDERS = new InjectionToken<ConfigProvider[]>('APP_CONFIG_PROVIDERS');
